export default __webpack_public_path__ + "static/media/blur.34a81479.png";